// eslint-disable-next-line no-restricted-imports
import { browserEventsRecorder, consoleIntegration, glovoRum } from '@glovo/rum'
// eslint-disable-next-line no-restricted-imports
import type { ErrorContext } from '@glovo/rum'
import { setOnError, setOnFeatureInit } from '../error-tracking/event-handlers'

export const initConsoleIntegration = () => {
  glovoRum.init({
    recorder: browserEventsRecorder(window),
    stackTraceLimit: 50,
    integrations: [consoleIntegration(console)],
  })
  glovoRum.setContext('authenticated', false)
  glovoRum.setContext('address', false)

  setOnError((error, ctx) => {
    glovoRum.addError(error as Error, ctx as unknown as ErrorContext)
  })

  setOnFeatureInit((event, ctx) => {
    glovoRum.addAction(event, ctx)
  })
}
